import { Link } from "react-router-dom";

export const Logo = ({ light = false, className = "" }) => (
  <Link to="/" data-testid="logo-link" className={`group inline-flex items-center gap-2.5 ${className}`}>
    <span className="relative grid place-items-center shrink-0">
      {light && (
        <span
          aria-hidden="true"
          className="pointer-events-none absolute -inset-2.5 rounded-full blur-lg opacity-70 transition-opacity duration-200 group-hover:opacity-100"
          style={{ background: "radial-gradient(closest-side, hsl(var(--accent) / 0.7), transparent)" }}
        />
      )}
      <img
        src={`${process.env.PUBLIC_URL || ""}/favicon-512.png`}
        alt="GatherVoices"
        width="36"
        height="36"
        className="relative h-9 w-9 rounded-[10px] object-contain"
      />
    </span>
    <span className="font-display text-xl font-semibold tracking-tight leading-none">
      <span className={light ? "text-white" : "text-[hsl(var(--foreground))]"}>Gather</span>
      <span className="text-[hsl(var(--accent))]">Voices</span>
    </span>
  </Link>
);

export const StatusChip = ({ status }) => {
  const map = {
    draft: { bg: "34 22% 93%", fg: "24 10% 38%", label: "Draft" },
    collecting: { bg: "196 55% 92%", fg: "196 70% 18%", label: "Collecting" },
    compiling: { bg: "38 85% 90%", fg: "28 22% 18%", label: "Compiling" },
    ready: { bg: "152 30% 92%", fg: "152 40% 16%", label: "Ready" },
  };
  const s = map[status] || map.draft;
  return (
    <span data-testid={`status-chip-${status}`} className="inline-flex items-center gap-1.5 rounded-full px-3 py-1 text-xs font-semibold"
      style={{ background: `hsl(${s.bg})`, color: `hsl(${s.fg})` }}>
      <span className="h-1.5 w-1.5 rounded-full" style={{ background: `hsl(${s.fg})` }} />
      {s.label}
    </span>
  );
};
